import { Button } from 'common/Components/Button';
import { AlreadyActivedIcon } from 'common/Icons';
import { useRouter } from 'common/hooks/useRouter';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setAccountActivationStep } from 'redux/common/AccountActivationSlice';

const AlreadyActived = () => {
  //
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { navigate } = useRouter();

  const goToLoginPage = () => {
    dispatch(setAccountActivationStep('Agreement'));
    navigate.pushLogin();
  };

  return (
    <div className="flex flex-col gap-6 items-center">
      <h1 className="text-5xl font-bold text-center text-L-info-100 mt-4">
      {t(`BrokerCode_${window.api?.BROKER_CODE}.Activation.already_actived_label`)}
      </h1>
      <AlreadyActivedIcon />
      <span className="text-xl !font-medium md:text-b2xl  text-L-primary-50 ">
      {t(`BrokerCode_${window.api?.BROKER_CODE}.Activation.already_actived_details`)}
      </span>
      <div className="w-full mt-12">
        <Button
          onClick={goToLoginPage}
          className="w-full bg-L-secondary-50 dark:bg-D-secondary-50 rounded text-L-basic dark:text-D-basic p-2 text-3xl mb-6"
        >
          {t(`FormSide.goToLoginPage`)}
        </Button>
      </div>
    </div>
  );
};

export default AlreadyActived;
